import { Box } from '@mui/material';
import { ReactNode } from 'react';

// Fills the season window: the content scrolls, and the footer's buttons stay at the bottom.
export default function HedgePlanSeasonTabLayout(props: { children: ReactNode; footer: ReactNode }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', paddingRight: 1 }}>
        {props.children}
      </Box>
      <Box sx={{ flexShrink: 0, borderTop: '1px solid var(--box-border-color)', paddingTop: 1 }}>
        {props.footer}
      </Box>
    </Box>
  );
}
